import type { FlashData } from "@/types"

type AuthStatusProps = {
  errorSummary?: string[]
  flash: FlashData
}

function Banner({
  children,
  tone,
}: {
  children: React.ReactNode
  tone: "alert" | "notice"
}) {
  const classes =
    tone === "notice"
      ? "border-emerald-200 bg-emerald-50/90 text-emerald-950"
      : "border-rose-200 bg-rose-50/90 text-rose-950"

  return (
    <div className={`rounded-2xl border px-4 py-3 text-sm shadow-sm ${classes}`}>
      {children}
    </div>
  )
}

export function AuthStatus({ errorSummary = [], flash }: AuthStatusProps) {
  const alertMessage = flash.alert?.trim()
  const summary = [...new Set(errorSummary.filter(Boolean))].filter(
    (message) => message !== alertMessage
  )

  if (!flash.notice && !alertMessage && summary.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      {flash.notice && <Banner tone="notice">{flash.notice}</Banner>}
      {alertMessage && <Banner tone="alert">{alertMessage}</Banner>}
      {summary.length > 0 && (
        <Banner tone="alert">
          <p className="font-semibold">Please fix the following before continuing.</p>
          <ul className="mt-2 ml-5 list-disc">
            {summary.map((message) => (
              <li className="mt-1 first:mt-0" key={message}>
                {message}
              </li>
            ))}
          </ul>
        </Banner>
      )}
    </div>
  )
}
